import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  PENDINGCOMMENTS: {
    path: `${baseRoutes.userBaseRoutes}pending-comments`,
  },
};

export default accessRoute;
